import { AddressSearchResult } from "../../platform/modules/retrieval/address-search/address-search-result.model";

export class RetrievalUtilities {
  static getDocumentSourceTypeName(selectedAddress: AddressSearchResult): string {
    if (selectedAddress) {

      let documentSource = "";

      switch (selectedAddress.documentSourceTypeName) {
        case "EMR": {
          documentSource = "emr";
          break;
        }

        case "Field Tech": {
          documentSource = "ft";
          break;
        }

        case "PSR":

        default: {
          documentSource = "address";
          break;
        }
      }

      return documentSource;
    }
  }

  static getDocumentSourceType(retrievalType: string): string {
    const documentSourceMap: Record<string, string> = {
      psr: "PSR",
      emr: "EMR",
      ft: "Field Tech",
      thirdparty: "3rd Party",
      sh: "",
    };

    const documentSource = documentSourceMap[retrievalType.toLowerCase()];
    return documentSource !== undefined ? documentSource : retrievalType;
  }
}
